import { render, staticRenderFns } from "./home-how-it-works-v2-item.vue?vue&type=template&id=e5629baa&scoped=true&"
import script from "./home-how-it-works-v2-item.vue?vue&type=script&lang=js&"
export * from "./home-how-it-works-v2-item.vue?vue&type=script&lang=js&"
import style0 from "./home-how-it-works-v2-item.vue?vue&type=style&index=0&id=e5629baa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5629baa",
  null
  
)

export default component.exports